__turbopack_context__.v({
  "saveIcon": "vgg9-q_saveIcon",
});
